import { lazy } from 'react';
import { RouteObject } from 'react-router';

import { IntegrationSystem } from '@/shared/types';

import { createSystemRoutes, RoutesBySystem } from '@/router/utils';

import { PAY_ROUTES } from './config';

const PaymentReceipts = lazy(() => import('../pages/PaymentReceipts/PaymentReceipts'));
const ServicePaymentWithoutApplication = lazy(() => import('../pages/services/ServicePaymentWithoutApplication'));

const paySystemComponents: Record<
  keyof RoutesBySystem<IntegrationSystem.PAY>,
  React.LazyExoticComponent<React.FC<any>>
> = {
  PAYMENT_WITHOUT_APPLICATION: ServicePaymentWithoutApplication,
  PAYMENT_RECEIPTS: PaymentReceipts,
};

export const PayRouter: RouteObject = createSystemRoutes(IntegrationSystem.PAY, PAY_ROUTES, paySystemComponents);
